import { createSlice } from '@reduxjs/toolkit'
import WSUtils from '../../utils/ws-utils';

const MESSAGES_BASE_VIRTUAL_TIMESTAMP = 100000000000;
const DEFAULT_LAST_TS = MESSAGES_BASE_VIRTUAL_TIMESTAMP + 1;

// Initial load / Next Page (Do nothing if no more messages): 
// store.dispatch({ type: 'messages/loadMessages', payload: { mid: "swensens:82089151" } })

function initStateForMember(state, mid) {
  if (!state.value[mid]) {
    state.value[mid] = {
      info: { mid },
      statistics: {},
      messages: [],
      lastTS: DEFAULT_LAST_TS,
      moreMessages: true,
    }
  }
}

export const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    value: {},
  },
  reducers: {
    loadMessages: (state, { payload }) => {
      const mid = payload?.mid;
      initStateForMember(state, mid);
      if (!!state.value[mid].lastTS) {
        WSUtils.send({
          'action': 'load-messages',
          mid,
          lastTS: state.value[mid].lastTS
        })
      }
    },
    receive: (state, { payload }) => {
      const data = payload;
      const mid = data.mid;
      const ts = data.ts;
      initStateForMember(state, mid)
      const messages = state.value[mid].messages;
      if (!messages.find(item => item.ts === ts)) {
        messages.push(data);
        messages.sort(({ts: ts1}, {ts: ts2}) => ts2 < ts1 ? -1 : 1);
      }
    },
    receiveMany: (state, { payload }) => {
      const msgs = payload.messages;
      const lastTS = payload.lastTS;
      if (msgs.length > 0) {
        const mid = msgs[0].mid;
        initStateForMember(state, mid)
        const messages = state.value[mid].messages;
        msgs.forEach((msg) => {
          if (msg.ts === MESSAGES_BASE_VIRTUAL_TIMESTAMP) {
            state.value[mid].info = msg.data;
            state.value[mid].statistics = msg.statistics;
          } else {
            messages.push(msg);
          }
        });
        messages.sort(({ts: ts1}, {ts: ts2}) => ts2 < ts1 ? -1 : 1);
        state.value[mid].lastTS = lastTS;
        state.value[mid].moreMessages = !!lastTS;
      }
    },
    memberInformationUpdate: (state, { payload }) => {
      const data = payload;
      const mid = data.mid;
      initStateForMember(state, mid);
      state.value[mid].info = payload;
    }
  },
})

export const { loadMessages, receive, memberInformationUpdate, receiveMany } = messagesSlice.actions

let store = null;
export function configureWithStore(_store) {
  if (!store) {
    store = _store;
    WSUtils.addMessageHandlerForEvent('messages-loaded', payload => {
      store.dispatch(receiveMany(payload.data))
    });

    WSUtils.addMessageHandlerForEvent('chat-message', payload => {
      store.dispatch(receive(payload.data))
    });
    WSUtils.addMessageHandlerForEvent('member-information-update', payload => {
      store.dispatch(memberInformationUpdate(payload.data))
    });
  }
}

export default messagesSlice.reducer